import { REGISTER_ACCESS_CODE } from './index';
import { Action } from '../action';
import { AccessCodeSearchInfo } from '@shared/core';

export class RegisterAccessCodeInitAction implements Action {
	readonly type = REGISTER_ACCESS_CODE.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterAccessCodeDestroyAction implements Action {
	readonly type = REGISTER_ACCESS_CODE.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterAccessCodeClickSubmitAction implements Action {
	readonly type = REGISTER_ACCESS_CODE.CLICK_SUBMIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterAccessCodeClickIgnoreAction implements Action {
	readonly type = REGISTER_ACCESS_CODE.CLICK_IGNORE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterAccessCodeFormUpdateAction implements Action {
	readonly type = REGISTER_ACCESS_CODE.FORM_UPDATE;
	constructor(
		public payload: AccessCodeSearchInfo,
		public correlationId?: number
	) {}
}

export class RegisterAccessCodeFormResetAction implements Action {
	readonly type = REGISTER_ACCESS_CODE.FORM_RESET;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
